// Shared case presentation helpers, previously duplicated verbatim in
// pages/Cases.js and pages/CaseDetail.js.

export const statusColors = {
  open: 'bg-blue-100 text-blue-800',
  in_progress: 'bg-yellow-100 text-yellow-800',
  pending: 'bg-orange-100 text-orange-800',
  closed: 'bg-gray-100 text-gray-800',
};

export const priorityColors = {
  low: 'bg-slate-100 text-slate-800',
  medium: 'bg-blue-100 text-blue-800',
  high: 'bg-orange-100 text-orange-800',
  urgent: 'bg-red-100 text-red-800',
};

/**
 * Resolve an attorney's display name from a list. `fallback` is returned when
 * no match is found ('Unassigned' on the case list, 'Unknown' on detail views).
 */
export const attorneyName = (attorneys, id, fallback = 'Unassigned') => {
  const attorney = (attorneys || []).find((a) => a.id === id);
  return attorney ? attorney.full_name : fallback;
};
